// Sentry error tracking initialization for frontend
import * as Sentry from "@sentry/browser";

// Get configuration from HTML data attributes
const railsEnv = document.documentElement.dataset.railsEnv || "production";
const sentryEnabled = document.documentElement.dataset.sentryEnabled === "true";
const sentryDsn = document.documentElement.dataset.sentryDsn || "";

// Initialize Sentry
// Only enable in production (controlled by data-sentry-enabled attribute)
Sentry.init({
  dsn: sentryDsn,
  
  // Enable based on the data attribute from Rails
  enabled: sentryEnabled && !!sentryDsn,
  
  // Set environment from Rails
  environment: railsEnv,
  
  // Capture unhandled promise rejections
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  
  // Set sample rate for performance monitoring
  tracesSampleRate: 0.1,
  
  // Set sample rate for session replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  // Ignore some common non-critical errors
  ignoreErrors: [
    // Browser extensions
    'top.GLOBALS',
    // Random plugins/extensions
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    // Facebook
    'fb_xd_fragment',
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // ResizeObserver errors (common and usually harmless)
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
  ],
  
  // Configure which URLs to track
  denyUrls: [
    // Browser extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
  ],
  
  // Add extra context
  beforeSend(event, hint) {
    // Add custom context if available
    if (window.currentUser) {
      event.user = {
        id: window.currentUser.id,
        email: window.currentUser.email,
      };
    }
    
    // Log to console in development
    if (railsEnv === "development") {
      console.error("Sentry Error:", hint.originalException || hint.syntheticException);
    }
    
    return event;
  },
});

// Export Sentry instance for manual error reporting
window.Sentry = Sentry;

// Global error handler for AJAX errors (only if jQuery is loaded)
// Use DOMContentLoaded to ensure jQuery is available
document.addEventListener('DOMContentLoaded', function() {
  if (window.jQuery) {
    $(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
      // Don't report aborted requests
      if (jqXHR.statusText === 'abort') {
        return;
      }
      
      Sentry.captureException(new Error(`AJAX Error: ${ajaxSettings.url} - ${thrownError || jqXHR.statusText}`), {
        contexts: {
          ajax: {
            url: ajaxSettings.url,
            type: ajaxSettings.type,
            status: jqXHR.status,
            statusText: jqXHR.statusText,
            responseText: jqXHR.responseText ? jqXHR.responseText.substring(0, 500) : '',
          }
        }
      });
    });
  }
});
